<template>
    <div class="ag-custom-loading-cell" style="padding-left: 10px; line-height: 25px;">
            <i class="fas fa-spinner fa-pulse"></i> <span>loading</span>
        </div>
</template>
        
<script>
export default {
       data () {
        return {
        };
    },
    beforeMount() {
    },
    mounted() {
    },
    methods: {
    } 
}
</script>


